import React from 'react';
import { ReactComponent as FilterIcon } from 'src/assets/images/filter.svg';
import { White } from 'src/styles/colours';
import styled from 'styled-components';

const StyledSearchSection = styled.section`
  background-color: ${White};
  border-radius: 0.25rem;
  margin-bottom: 2rem;
  @media print {
    display: none;
  }
`;

const StyledSearches = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  padding: 2.2rem 1rem 2.2rem 2rem;
`;

const StyledIconContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: 1rem;
`;

const StyledFilterText = styled.span`
  margin-right: 1.5rem;
`;

export const SearchControls = ({ children }: { children: React.ReactNode }) => (
  <StyledSearchSection>
    <StyledSearches>
      <StyledIconContainer>
        <FilterIcon />
      </StyledIconContainer>
      <StyledFilterText>Filter by</StyledFilterText>
      {children}
    </StyledSearches>
  </StyledSearchSection>
);
